import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-703cd7b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "station-registration-section",
  "data-testid": "station-registration-section",
  class: "station-registration-card flex flex-col rounded-lg px-3 py-3 md:px-4"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-start gap-2 py-3 text-left",
  "data-testid": "station-registration-error"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-negative" }, "Não foi possível calcular o horário efetivo deste plantão.", -1))
const _hoisted_4 = { class: "text-xs text-gray-500" }
const _hoisted_5 = { class: "flex flex-wrap items-center gap-2 pb-3" }
const _hoisted_6 = {
  key: 0,
  class: "m-0 mb-3 rounded border border-gray-30 bg-gray-50 px-2 py-1.5 text-left text-xs text-gray-600",
  "data-testid": "station-registration-frozen-banner"
}
const _hoisted_7 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = { class: "flex flex-wrap items-center justify-between gap-2" }
const _hoisted_10 = { class: "text-xs font-bold uppercase tracking-wide text-gray-500" }
const _hoisted_11 = { class: "flex items-center gap-1" }
const _hoisted_12 = { class: "flex flex-wrap items-baseline gap-2" }
const _hoisted_13 = { class: "text-2xl font-bold leading-none" }
const _hoisted_14 = { class: "text-xs text-gray-500" }
const _hoisted_15 = { class: "flex flex-col gap-1 text-xs" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "font-semibold" }
const _hoisted_18 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_19 = {
  key: 2,
  class: "text-gray-500"
}
const _hoisted_20 = {
  key: 0,
  class: "flex flex-wrap items-center justify-end gap-2"
}
const _hoisted_21 = { class: "text-xs text-gray-500" }
const _hoisted_22 = {
  key: 1,
  class: "flex flex-wrap items-center justify-start gap-2 pt-3",
  "data-testid": "station-registration-actions"
}
const _hoisted_23 = {
  key: 0,
  "data-testid": "station-registration-cta"
}
const _hoisted_24 = {
  class: "mt-3 border-t border-gray-30 pt-2 text-left text-xs text-gray-500",
  "data-testid": "station-registration-footer"
}
const _hoisted_25 = {
  key: 0,
  class: "station-grid-container flex flex-wrap gap-3 md:gap-4 py-2 px-1 md:px-2"
}
const _hoisted_26 = { class: "station-block station-block--check flex flex-col gap-2 md:gap-3 min-w-0" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm md:text-base whitespace-nowrap" }, "Check-in", -1))
const _hoisted_28 = { class: "flex flex-row flex-wrap gap-2 min-w-0" }
const _hoisted_29 = { class: "station-field flex flex-row items-center rounded border border-gray-30 gap-1 md:gap-2 py-1.5 md:py-2 px-2 min-w-0" }
const _hoisted_30 = { class: "text-sm md:text-base whitespace-nowrap" }
const _hoisted_31 = { class: "station-field station-field--time flex flex-row flex-wrap items-center rounded border border-gray-30 gap-1 md:gap-2 py-1.5 md:py-2 px-2 min-w-0" }
const _hoisted_32 = { class: "text-sm md:text-base whitespace-nowrap" }
const _hoisted_33 = { class: "station-block station-block--check flex flex-col gap-2 md:gap-3 min-w-0" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm md:text-base whitespace-nowrap" }, "Check-out", -1))
const _hoisted_35 = { class: "flex flex-row flex-wrap gap-2 min-w-0" }
const _hoisted_36 = { class: "station-field flex flex-row items-center rounded border border-gray-30 gap-1 md:gap-2 py-1.5 md:py-2 px-2 min-w-0" }
const _hoisted_37 = { class: "text-sm md:text-base whitespace-nowrap" }
const _hoisted_38 = { class: "station-field station-field--time flex flex-row flex-wrap items-center rounded border border-gray-30 gap-1 md:gap-2 py-1.5 md:py-2 px-2 min-w-0" }
const _hoisted_39 = { class: "text-sm md:text-base whitespace-nowrap" }
const _hoisted_40 = { class: "station-block station-block--origin flex flex-col gap-2 md:gap-3 min-w-0" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm md:text-base whitespace-nowrap" }, "Registro", -1))
const _hoisted_42 = { class: "flex flex-row items-center rounded border border-gray-30 gap-1 md:gap-2 py-1.5 md:py-2 px-2 w-full min-w-0" }
const _hoisted_43 = { class: "text-sm md:text-base break-words" }
const _hoisted_44 = { class: "station-block station-block--verification flex flex-col gap-2 md:gap-3 min-w-0" }
const _hoisted_45 = { class: "font-bold text-sm md:text-base whitespace-nowrap" }
const _hoisted_46 = { class: "flex flex-row items-center rounded border border-gray-30 gap-1 md:gap-2 py-1.5 md:py-2 px-2 w-full min-w-0" }
const _hoisted_47 = {
  key: 1,
  class: "text-sm md:text-base text-gray-500",
  "data-testid": "verification-none"
}
const _hoisted_48 = { class: "station-block station-block--evidence flex flex-col gap-2 md:gap-3 min-w-0" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm md:text-base whitespace-nowrap" }, "Evidência", -1))
const _hoisted_50 = { class: "flex flex-row items-center rounded border border-gray-30 gap-1 md:gap-2 py-1.5 md:py-2 px-2 w-full min-w-0" }
const _hoisted_51 = {
  key: 2,
  class: "text-sm md:text-base text-gray-500"
}
const _hoisted_52 = {
  key: 1,
  class: "station-empty-state flex justify-center items-center py-3 px-2"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Este plantão não possui registro de presença", -1))
const _hoisted_54 = [
  _hoisted_53
]

import { computed } from 'vue'
import Calendar from '@/assets/icons/calendar.vue'
import Clock from '@/assets/icons/clock.vue'
import CollapsibleSection from './CollapsibleSection.vue'
import StationSourceHistoryAccordion from './StationSourceHistoryAccordion.vue'
import type { SupersededSource } from './StationSourceHistoryAccordion.vue'
import SVGIcon from '@/components/SVGIcon.vue'
import { mdiLockOpenVariant } from '@mdi/js'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { LabelBadgeColor } from '@/components/designSystem/Badges/LabelBadge.vue'
import PermanenceLinkRow from '@/components/designSystem/Cards/PermanenceLinkRow.vue'
import { ExceptionSummary } from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import { CheckEvidence } from '@/Network/Types/Requests/StationRequests'
import type {
  StationRegistration,
  StationRegistrationActivityRecord,
  StationRegistrationHistoryEntry,
  StationRegistrationLeg,
  StationRegistrationLegDto
} from '@/Network/Services/StationService'
import type { PermanenceVisibility } from '@/utils/permanence'
import type { DSAttendanceActivityAttachment } from '@/types/ds-attendance.types'
import type {
  StationEvidenceContext,
  StationEvidenceLeg,
  StationSourceOrigin
} from '@/types/station-evidence.types'
import {
  VERIFICATION_BUTTON_LABELS,
  VERIFICATION_COLUMN_HEADER
} from '@/constants/check-verification.constants'
import { getVerificationButtonState } from '@/utils/check-verification'
import {
  DSAttendanceStatus,
  EFFECTIVE_REGISTRATION_STATUS_LABELS,
  EFFECTIVE_SOURCE_KIND_LABELS,
  EffectiveRegistrationStatus,
  EffectiveSourceKind,
  REGISTRATION_NOT_EVALUATED_LABEL
} from '@/constants/ds-attendance.constants'
import {
  formatDateInOffset,
  formatDateTimeWithOffset,
  formatHourMinuteInOffset
} from '@/utils/date'

interface FormattedDateTime {
  weekday: string
  date: string
  time: string
}

/**
 * Resposta de `GET /stations/:doctorStationId/registration`.
 *
 * O contrato mora no `StationService`; estes apelidos existem porque o modal e o
 * spec desta seção já os importam daqui. Os campos além do recorte mínimo
 * (`expected`, `computedAt`, `ruleVersion`, `frozenAt`) são opcionais: o backend
 * da F2 ainda não existe e a tela omite o que não vier.
 */
export type StationRegistrationLegView = StationRegistrationLeg
export type StationRegistrationView = StationRegistration

interface LegView {
  key: 'checkin' | 'checkout'
  title: string
  time: string
  at: string | null
  timeDetail: string
  sourceLabel: string | null
  emptyLabel: string
  rankLabel: string | null
  verified: boolean
  declared: boolean
  origin: StationSourceOrigin | null
  /** Anexos do Registro de Atividade que originou a perna; vazio nas demais fontes. */
  attachments: DSAttendanceActivityAttachment[]
  supersededSources: SupersededSource[]
}

/** `99` = fonte fora do ranking configurado para a escala (F1). */

export default /*#__PURE__*/_defineComponent({
  __name: 'StationRegistrationSection',
  props: {
    exceptionSummary: {},
    showDoctorCheck: { type: Boolean },
    mainCheck: {},
    permanenceVisibility: {},
    attendanceStatus: {},
    loadingDsEvidence: { type: Boolean },
    hasStationStarted: { type: Boolean },
    hasStationEnded: { type: Boolean },
    canReadDoctorCheck: { type: Boolean },
    isConciliationOrigin: { type: Boolean },
    checkin: {},
    checkout: {},
    registration: { default: null },
    loadError: { default: null },
    expectedCheckin: { default: null },
    expectedCheckout: { default: null },
    timezone: { default: '-03:00' },
    canSendRecord: { type: Boolean, default: false },
    ourTeam: { type: [Boolean, null], default: null },
    touchTarget: { type: Boolean, default: false }
  },
  emits: ["navigateToStation", "openEvidence", "openDsAttendanceEvidence", "openVerification", "retryRegistration", "sendRecord", "viewEvidence"],
  setup(__props: any, { emit }) {

const props = __props;





// Check-out ausente tem dois significados opostos e o texto precisa distingui-los:
// num plantão que ainda não terminou o registro está por vir ("Aguardando"), num
// plantão já encerrado ele deixou de acontecer e é uma pendência real do gestor.
const missingCheckoutLabel = computed(() =>
  props.hasStationEnded ? 'Não registrado' : 'Aguardando'
)

// Qual botão a coluna "Local e biometria" mostra. A regra vive em
// `getVerificationButtonState` (função pura, testada) porque depende do
// `checkMethod` do backend — não da origem do registro nem dos anexos.
const verificationState = computed(() => getVerificationButtonState(props.mainCheck))

const STATUS_COLORS: Record<EffectiveRegistrationStatus, LabelBadgeColor> = {
  [EffectiveRegistrationStatus.OK]: 'green',
  [EffectiveRegistrationStatus.PARTIAL]: 'orange',
  [EffectiveRegistrationStatus.PENDING]: 'yellow',
  [EffectiveRegistrationStatus.NONE]: 'red',
  [EffectiveRegistrationStatus.NOT_REQUIRED]: 'gray'
}

/**
 * O payload CRU de `GET /stations/:id/registration` (F4). O recorte achatado que
 * o resto do componente lê é uma tradução feita na camada de rede; tudo o que a
 * tela por perna precisa a mais — histórico com veredito, Registros de Atividade
 * da vaga, `frozen.reason`, a fonte como objeto — só existe aqui.
 */
const raw = computed(() => props.registration?.raw ?? null)

const isFrozen = computed(() => Boolean(props.registration?.frozenAt))

const frozenText = computed(() => {
  const reason = raw.value?.frozen?.reason
  if (reason) return reason

  const at = props.registration?.frozenAt
  const when = at ? formatDateTimeWithOffset(at, props.timezone) : null
  return `${when ? `Pós-plantão aprovado em ${when}. ` : ''}O horário efetivo está congelado. Novos registros continuam sendo aceitos e auditados, mas só passam a valer se o pós-plantão for reaberto.`
})

/**
 * "Não avaliado" (M5, balão ⑤): plantão fora da vigência de qualquer política de
 * registro. "Sem registro" ali seria uma acusação — o plantão não deixou de
 * registrar, ele nunca foi avaliado.
 *
 * A F4-FX2 passou a servir `policyInEffect` nesta rota, e é ele que manda: era a
 * SEGUNDA derivação da mesma pergunta (o pós-plantão já lia
 * `registrationPolicyInEffect`) e duas fontes de verdade divergem no primeiro
 * caso de borda. A derivação antiga ("o motor da F1 nunca rodou para esta vaga")
 * fica só como fallback de binário anterior à FX2, onde o campo vem `undefined`.
 */
const isNotEvaluated = computed(() => {
  const payload = raw.value
  if (!payload) return false
  if (payload.policyInEffect !== undefined) return !payload.policyInEffect
  return !payload.computedAt && payload.ruleVersion == null
})

/**
 * "Em andamento" (M1, Tela 3): plantão que ainda não terminou não tem check-out
 * "faltando" — ele está por vir. O chip do topo diz isso em vez de acusar
 * pendência que ainda não existe.
 */
const isOngoing = computed(() => !props.hasStationEnded && !props.registration?.checkout?.value)

/**
 * Q1 — fora do time e sem registro completo: "Não exigido" (neutro). Com registro OK o chip
 * continua dizendo "Registro OK": a verdade das fontes não muda, só deixa de ser cobrança.
 */
const isNotRequired = computed(
  () => props.ourTeam === false && props.registration?.status !== EffectiveRegistrationStatus.OK
)

const statusLabel = computed(() => {
  if (isNotRequired.value)
    return EFFECTIVE_REGISTRATION_STATUS_LABELS[EffectiveRegistrationStatus.NOT_REQUIRED]
  if (isNotEvaluated.value) return REGISTRATION_NOT_EVALUATED_LABEL
  if (isOngoing.value) return 'Em andamento'
  const status = props.registration?.status
  return (
    props.registration?.statusLabel ||
    (status && EFFECTIVE_REGISTRATION_STATUS_LABELS[status]) ||
    'Sem registro'
  )
})

const statusColor = computed<LabelBadgeColor>(() => {
  if (isNotRequired.value) return 'gray'
  if (isNotEvaluated.value) return 'gray'
  if (isOngoing.value) return 'blue'
  const status = props.registration?.status
  return (status && STATUS_COLORS[status]) || 'gray'
})

const LEG_NAMES = { checkin: 'CHECKIN', checkout: 'CHECKOUT' } as const

const rankLabelOf = (rank: number | null | undefined): string | null => {
  if (rank == null) return null
  return rank === 99 ? 'Fora do ranking da escala' : `${rank}º no ranking aplicável`
}

/**
 * Histórico daquela perna, com o veredito de cada fonte. O cru (`history`) é a
 * fonte preferida porque separa `SUPERSEDED` de `DISCARDED`; a lista achatada do
 * normalizador (que marca tudo como superada) é o fallback para backend antigo.
 */
const historyFor = (key: 'checkin' | 'checkout', leg: StationRegistrationLeg | null) => {
  const history = raw.value?.history
  if (!history) return leg?.supersededSources ?? []

  return history
    .filter((entry: StationRegistrationHistoryEntry) => entry.leg === LEG_NAMES[key])
    .map((entry: StationRegistrationHistoryEntry) => ({
      source: entry.kind,
      value: entry.at ?? null,
      rank: entry.rank ?? null,
      outcome: entry.outcome,
      reason: entry.reason ?? null,
      label: entry.label ?? null
    }))
}

const AUDIT_IN_PROGRESS_STATUSES: string[] = [
  DSAttendanceStatus.PENDING_AUDIT,
  DSAttendanceStatus.AUDIT_IN_PROGRESS
]

/**
 * Horário DECLARADO e ainda não final (M1, Tela 3 — estado "Pendente"): existe um
 * Registro de Atividade em auditoria cobrindo a perna. Ele aparece na tela, com o
 * selo "declarado", mas não é o efetivo — e some assim que a perna resolve.
 */
const declaredFor = (key: 'checkin' | 'checkout'): string | null => {
  const records = raw.value?.activityRecords ?? []
  const pending = records.find((record: StationRegistrationActivityRecord) => {
    if (!AUDIT_IN_PROGRESS_STATUSES.includes(String(record.status))) return false
    return key === 'checkin' ? !!record.declaredCheckin : !!record.declaredCheckout
  })
  if (!pending) return null
  return (key === 'checkin' ? pending.declaredCheckin : pending.declaredCheckout) ?? null
}

/** A fonte vencedora como objeto, para o painel de origem. */
const originFor = (
  key: 'checkin' | 'checkout',
  leg: StationRegistrationLeg | null
): StationSourceOrigin | null => {
  const dto = (raw.value?.legs?.[key] ?? raw.value?.[key]) as StationRegistrationLegDto | undefined
  if (dto?.source) return dto.source
  if (!leg?.source) return null
  // Backend antigo: só o `kind` e o rank vieram achatados.
  return { kind: leg.source, rank: leg.sourceRank, refId: null, dsAttendanceContainerId: null }
}

/** Rótulo pt-BR da fonte vencedora; o do backend ganha do mapa local. */
const originLabel = (origin: StationSourceOrigin | null): string | null =>
  origin ? origin.label || EFFECTIVE_SOURCE_KIND_LABELS[origin.kind] : null

/**
 * Check-out ausente tem dois significados opostos: num plantão que ainda não
 * terminou o registro está por vir, num já encerrado ele deixou de acontecer.
 */
const emptyLegLabel = (key: 'checkin' | 'checkout'): string =>
  key === 'checkout' && !props.hasStationEnded ? 'Aguardando' : 'Sem fonte'

/** "12/09/2026 · previsto 07:00" — a linha de contexto abaixo do horário. */
const legTimeDetail = (at: string | null, expectedIso: string | null): string => {
  const date = at ? formatDateInOffset(at, props.timezone) : null
  const expectedTime = expectedIso ? formatHourMinuteInOffset(expectedIso, props.timezone) : null
  return [date, expectedTime ? `previsto ${expectedTime}` : null].filter(Boolean).join(' · ')
}

/**
 * Anexos do Registro de Atividade que venceu a perna. Casamos pelo container da
 * fonte, não pelo primeiro registro da lista: uma vaga pode ter vários, e o que
 * venceu o check-in não é necessariamente o que venceu o check-out.
 */
const attachmentsFor = (origin: StationSourceOrigin | null): DSAttendanceActivityAttachment[] => {
  if (origin?.kind !== EffectiveSourceKind.ACTIVITY_RECORD) return []
  const containerId = origin.dsAttendanceContainerId
  if (containerId == null) return []
  const record = (raw.value?.activityRecords ?? []).find(
    (item: StationRegistrationActivityRecord) => item.containerId === containerId
  )
  return record?.attachments ?? []
}

const buildLegView = (
  key: 'checkin' | 'checkout',
  title: string,
  leg: StationRegistrationLeg | null,
  expected: string | null
): LegView => {
  const declared = leg?.value ? null : declaredFor(key)
  const at = leg?.value ?? declared
  const time = at ? formatHourMinuteInOffset(at, props.timezone) : null
  const origin = originFor(key, leg)

  return {
    key,
    title,
    time: time ?? '--:--',
    at,
    timeDetail: legTimeDetail(at, leg?.expected ?? expected),
    sourceLabel: originLabel(origin),
    emptyLabel: emptyLegLabel(key),
    rankLabel: rankLabelOf(origin?.rank ?? leg?.sourceRank),
    verified: Boolean(leg?.verifiedAt),
    declared: Boolean(declared) || Boolean(leg?.declared),
    origin,
    attachments: attachmentsFor(origin),
    supersededSources: historyFor(key, leg)
  }
}

const legViews = computed<LegView[]>(() => {
  const registration = props.registration
  if (!registration) return []
  return [
    buildLegView('checkin', 'Check-in', registration.checkin, props.expectedCheckin),
    buildLegView('checkout', 'Check-out', registration.checkout, props.expectedCheckout)
  ]
})

const hasLegWithoutSource = computed(() => legViews.value.some((leg) => !leg.sourceLabel))

const hasAnyOrigin = computed(() => legViews.value.some((leg) => Boolean(leg.origin)))

function emitViewEvidence() {
  const legs: StationEvidenceLeg[] = legViews.value.map((leg) => ({
    key: leg.key,
    title: leg.title,
    at: leg.at,
    origin: leg.origin,
    attachments: leg.attachments
  }))
  // Abre na primeira perna COM fonte: abrir num estado vazio faria o gestor achar
  // que não há evidência nenhuma.
  const initialLeg = legs.find((leg) => leg.origin)?.key ?? 'checkin'
  emit('viewEvidence', { legs, initialLeg, timezone: props.timezone })
}

const footerText = computed(() => {
  const registration = props.registration
  if (!registration) return ''

  const parts: string[] = []
  if (registration.computedAt) {
    parts.push(
      `Horário efetivo calculado em ${formatDateTimeWithOffset(
        registration.computedAt,
        props.timezone
      )}`
    )
  }
  if (registration.ruleVersion != null) {
    parts.push(`regra de ranking v${registration.ruleVersion}`)
  }
  if (raw.value?.legacy) {
    parts.push('valor herdado da base anterior ao ranking')
  }
  parts.push('o recálculo não marca o plantão como “alterado após auditoria”')
  return `${parts.join(' · ')}.`
})

function openEvidence(files: CheckEvidence[]) {
  emit('openEvidence', files)
}

function openDsAttendanceEvidence() {
  emit('openDsAttendanceEvidence')
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.canReadDoctorCheck && _ctx.hasStationStarted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CollapsibleSection, {
          title: "Registro de plantão",
          "test-id": "duty-log-accordion",
          "touch-target": _ctx.touchTarget,
          "expand-label": "Ver registros de plantão",
          "collapse-label": "Ocultar registros de plantão"
        }, {
          "title-prefix": _withCtx(() => [
            (_ctx.exceptionSummary)
              ? (_openBlock(), _createBlock(SVGIcon, {
                  key: 0,
                  path: _unref(mdiLockOpenVariant),
                  class: "inline-block w-4 h-4 text-negative align-text-bottom mr-1"
                }, null, 8, ["path"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_ctx.loadError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.loadError), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-sm font-semibold text-primary30 underline",
                    "data-testid": "station-registration-retry",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retryRegistration')))
                  }, " Tentar novamente ")
                ]))
              : (_ctx.registration)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(LabelBadge, {
                        label: statusLabel.value,
                        color: statusColor.value,
                        size: "small",
                        icon: null,
                        "data-testid": "station-registration-status-chip"
                      }, null, 8, ["label", "color"]),
                      (isFrozen.value)
                        ? (_openBlock(), _createBlock(LabelBadge, {
                            key: 0,
                            label: "Fechado",
                            color: "gray",
                            size: "small",
                            icon: null,
                            "data-testid": "station-registration-frozen-chip"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    (isFrozen.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(frozenText.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(legViews.value, (leg) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: leg.key,
                          class: "flex flex-col gap-2 rounded border border-gray-30 p-3 text-left",
                          "data-testid": `station-registration-leg-${leg.key}`
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(leg.title), 1),
                            _createElementVNode("span", _hoisted_11, [
                              (isFrozen.value)
                                ? (_openBlock(), _createBlock(LabelBadge, {
                                    key: 0,
                                    label: "congelado",
                                    color: "gray",
                                    size: "small",
                                    icon: null,
                                    "data-testid": `station-registration-leg-frozen-${leg.key}`
                                  }, null, 8, ["data-testid"]))
                                : _createCommentVNode("", true),
                              (leg.verified)
                                ? (_openBlock(), _createBlock(LabelBadge, {
                                    key: 1,
                                    label: "Verificado",
                                    color: "green",
                                    size: "small",
                                    icon: null
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(leg.time), 1),
                            (leg.declared)
                              ? (_openBlock(), _createBlock(LabelBadge, {
                                  key: 0,
                                  label: "declarado",
                                  color: "yellow",
                                  size: "small",
                                  icon: null,
                                  "data-testid": `station-registration-leg-declared-${leg.key}`
                                }, null, 8, ["data-testid"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(leg.timeDetail), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            (leg.sourceLabel)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                  _createTextVNode("Fonte: "),
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(leg.sourceLabel), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(leg.emptyLabel), 1)),
                            (leg.declared)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Horário declarado — não entra no efetivo até a aprovação."))
                              : _createCommentVNode("", true)
                          ]),
                          (leg.rankLabel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(leg.rankLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(StationSourceHistoryAccordion, {
                            sources: leg.supersededSources,
                            "test-id": `station-source-history-accordion-${leg.key}`,
                            timezone: _ctx.timezone
                          }, null, 8, ["sources", "test-id", "timezone"])
                        ], 8, _hoisted_8))
                      }), 128))
                    ]),
                    ((hasLegWithoutSource.value && _ctx.canSendRecord) || hasAnyOrigin.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (hasLegWithoutSource.value && _ctx.canSendRecord)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded border border-solid border-primary30 px-3 py-1.5 text-sm font-semibold text-primary30 hover:bg-primary5",
                                  "data-testid": "station-registration-send-record",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('sendRecord')))
                                }, " Enviar registro ")
                              ]))
                            : _createCommentVNode("", true),
                          (hasAnyOrigin.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "rounded border border-solid border-primary30 px-3 py-1.5 text-sm font-semibold text-primary30 hover:bg-primary5",
                                "data-testid": "station-registration-view-evidence-button",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (emitViewEvidence()))
                              }, " Ver evidências "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(footerText.value), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.showDoctorCheck)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(Calendar, {
                                  width: 16,
                                  height: 16
                                }),
                                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.checkin?.date ? _ctx.checkin?.date : 'Não registrado'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(Clock),
                                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.checkin?.time ? _ctx.checkin?.time : '--:--'), 1),
                                (_ctx.permanenceVisibility.showCheckinChip)
                                  ? (_openBlock(), _createBlock(LabelBadge, {
                                      key: 0,
                                      label: "🔗 PERMANÊNCIA",
                                      color: "blue",
                                      size: "small",
                                      icon: null,
                                      "data-testid": "permanence-checkin-chip"
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createVNode(Calendar, {
                                  width: 16,
                                  height: 16
                                }),
                                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.checkout?.date ? _ctx.checkout?.date : missingCheckoutLabel.value), 1)
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _createVNode(Clock),
                                _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.checkout?.time ? _ctx.checkout?.time : '--:--'), 1),
                                (_ctx.permanenceVisibility.showCheckoutChip)
                                  ? (_openBlock(), _createBlock(LabelBadge, {
                                      key: 0,
                                      label: "🔗 PERMANÊNCIA",
                                      color: "blue",
                                      size: "small",
                                      icon: null,
                                      "data-testid": "permanence-checkout-chip"
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.mainCheck?.originLabel || 'Não identificado'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(VERIFICATION_COLUMN_HEADER)), 1),
                            _createElementVNode("div", _hoisted_46, [
                              (verificationState.value !== 'NONE')
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    color: verificationState.value === 'BIOMETRY' ? '#6B4FA3' : '#2F6F9F',
                                    depressed: "",
                                    class: "verification-btn station-action-btn w-full !text-white",
                                    "data-testid": "verification-button",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('openVerification', _ctx.mainCheck!.id)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(VERIFICATION_BUTTON_LABELS)[verificationState.value]), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_unref(VERIFICATION_BUTTON_LABELS).NONE), 1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _hoisted_49,
                            _createElementVNode("div", _hoisted_50, [
                              (_ctx.mainCheck?.checkEvidences?.length)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    color: "primary",
                                    depressed: "",
                                    class: "station-action-btn w-full",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (openEvidence(_ctx.mainCheck.checkEvidences)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.mainCheck.checkEvidences.length) + " Arquivo" + _toDisplayString(_ctx.mainCheck.checkEvidences.length > 1 ? 's' : ''), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.isConciliationOrigin && _ctx.attendanceStatus.containerId)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      color: "primary",
                                      depressed: "",
                                      class: "station-action-btn w-full",
                                      loading: _ctx.loadingDsEvidence,
                                      onClick: openDsAttendanceEvidence
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Visualizar ")
                                      ]),
                                      _: 1
                                    }, 8, ["loading"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_51, "Sem evidência"))
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
                  ], 64)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permanenceVisibility.links, (link) => {
              return (_openBlock(), _createBlock(PermanenceLinkRow, {
                key: `${link.direction}-${link.recordId}`,
                direction: link.direction,
                "station-label": link.stationLabel,
                "doctor-station-id": link.doctorStationId,
                "station-id": link.stationId,
                onNavigate: _cache[5] || (_cache[5] = (stationId) => emit('navigateToStation', stationId))
              }, null, 8, ["direction", "station-label", "doctor-station-id", "station-id"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["touch-target"])
      ]))
    : _createCommentVNode("", true)
}
}

})